import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

type PricingCardActionMode = 'hidden' | 'routerLink' | 'href' | 'static';

@Component({
  selector: 'app-pricing-card',
  imports: [LucideAngularModule, RouterLink],
  templateUrl: './pricing-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block h-full',
  },
})
export class PricingCard {
  readonly planName = input.required<string>();
  readonly price = input.required<string>();
  readonly pricePrefix = input<string | null>(null);
  readonly priceSuffix = input<string | null>(null);
  readonly features = input.required<readonly string[]>();
  readonly bestFor = input.required<string>();
  readonly ctaLabel = input.required<string>();
  readonly ctaRouterLink = input<string | null>(null);
  readonly ctaHref = input<string | null>(null);
  readonly ctaFragment = input<string | null>(null);
  readonly showCta = input(true);

  protected readonly actionMode = computed<PricingCardActionMode>(() => {
    if (!this.showCta()) {
      return 'hidden';
    }

    if (this.ctaRouterLink()) {
      return 'routerLink';
    }

    if (this.ctaHref()) {
      return 'href';
    }

    return 'static';
  });
}
